"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = miniPackages;

var _resourceHint = _interopRequireDefault(require("../common/resourceHint.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function miniPackages(_ref, requirejs, mobileView) {
  var document = _ref.document,
      serviceTopology = _ref.serviceTopology,
      _ref$rendererModel = _ref.rendererModel;
  _ref$rendererModel = _ref$rendererModel === void 0 ? {} : _ref$rendererModel;
  var clientSpecMap = _ref$rendererModel.clientSpecMap;
  requirejs(['lodash'], function (_) {
    var WIDGET = {
      GS: '1375babd-6f2b-87ed-ff19-5778602c8b86',
      IG: '14635280-8c8d-5346-b643-691f84f48973',
      EVENTS: '1440e92d-47d8-69be-ade7-e6de40127106',
      FAQ: '14c92de1-0e02-cbe5-98e9-c3de44d63a55'
    };

    function appHint(appDefinitionName) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          url = _ref2.url,
          widgetId = _ref2.widgetId;

      var app = _.find(clientSpecMap, {
        appDefinitionName: appDefinitionName
      });

      if (app) {
        if (!url) {
          if (widgetId && app.widgets) {
            var widget = app.widgets[widgetId];

            if (widget) {
              url = mobileView ? widget.mobileUrl : widget.widgetUrl;
            }
          }

          if (!url) {
            url = mobileView ? app.sectionMobileUrl : app.sectionUrl;

            if (!url && app.appWorkerUrl) {
              url = app.appWorkerUrl.replace(/[^/]+$/, '');
            }
          }
        }

        if (url) {
          (0, _resourceHint["default"])(document, 'preconnect', url);
        }
      }
    }

    if (_.find) {
      appHint('Wix Pro Gallery');
      appHint('Wix Blog');
      appHint('Wix Forum');
      appHint('Wix Stores');
      appHint('Wix Bookings');
      appHint('Wix Video', {
        url: serviceTopology.basePublicUrl
      });
      appHint('Wix Restaurants Menus');
      appHint('Wix Get Subscribers', {
        widgetId: WIDGET.GS
      });
      appHint('Instagram Feed', {
        widgetId: WIDGET.IG
      });
      appHint('Wix Events', {
        widgetId: WIDGET.EVENTS
      });
      appHint('Wix FAQ', {
        widgetId: WIDGET.FAQ
      });
    }
  });
}
//# sourceMappingURL=miniPackages.js.map